import csrfService from '../services/csrfService';

// paymentHandler.js
export class PaymentHandler {
  static async handleBetaPayment(betaData, stripeServerUrl, requestType) {
    // Validate required fields
    const { promoCode, email } = betaData;

    if (!promoCode || !email) {
      return {
        success: false,
        reason: 'invalid_input',
        message: 'Promo code and email are required'
      };
    }

    // Create payload data from form
    const payloadData = {
      promoCode: promoCode,
      email: email,
      request_type: requestType
    };

    console.log("Sending to server:", payloadData);

    const response = await csrfService.fetch(`${stripeServerUrl}/promo`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payloadData),
    });
    return await response.json();
  }

  static async handleStripePayment(modalType, promoInfo, stripeServerUrl) {

    try {
      const promoCode = promoInfo ? promoInfo.promoCode : null;
      const response = await csrfService.fetch(`${stripeServerUrl}/secret`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ modalType, promoCode}),
      });
      console.log('💰 PAYMENT: Response status:', response.status);
      const result = await response.json();
      console.log('💰 PAYMENT: Response data:', result);
      return result;
    } catch (error) {
      console.error('❌ PAYMENT: Payment request failed:', error);
      throw error;
    }
  }
}


// submissionHandler.js
export class SubmissionHandler {
  static async handleSubmission(modalType, form, apiUrl) {
    console.log("Handling submission for:", modalType);
    console.log("Form data to submit:", form);

    const endpoints = {
      'streamline': '/api/streamline',
      'tailor': '/api/tailor'
    };

    const endpoint = endpoints[modalType];
    if (!endpoint) throw new Error('Invalid modal type');

    if (!form) {
      throw new Error('No form data provided');
    }

    // This is the cleaned form data that will go to the API
    let formToSubmit = form;
    console.log("Sending request to:", `${apiUrl}${endpoint}`);

    const response = await csrfService.fetch(`${apiUrl}${endpoint}`, {
      method: 'POST',
      body: formToSubmit,
      headers: {},
    });

    const result = await response.json();

    // Generate PDF if we got resume_data but no pdf_data
    if (result.status === 'success' && result.resume_data && !result.pdf_data) {
      // We'll handle this in HomePage now
    }

    return result;
  }
}